import { MemberStatus } from './project-members.enum'
import type { PendingMemberIdPrefix, WorkspaceMember, WorkspaceMemberRole } from './project-members.interface'

export const normalizeInviteEmail = (email: string) => email.trim().toLowerCase()

export function buildPendingMember(
  email: string,
  role: WorkspaceMemberRole,
  projectId: string,
  idPrefix: PendingMemberIdPrefix
): WorkspaceMember {
  const member: WorkspaceMember = {
    id: `${idPrefix}-${Date.now()}-${email}`,
    name: null,
    email,
    avatarUrl: null,
    role,
    status: MemberStatus.PENDING,
    lastSeen: null,
    projectIds: [projectId],
  }

  if (idPrefix === 'workspace-member') {
    return { ...member, projectsCount: 1 }
  }

  return member
}

export function mergeProjectMembersList(
  serverMembers: WorkspaceMember[],
  pendingInvites: WorkspaceMember[]
): WorkspaceMember[] {
  const serverEmails = new Set(serverMembers.map((member) => normalizeInviteEmail(member.email)))
  const dedupedPending = pendingInvites.filter((pending) => !serverEmails.has(normalizeInviteEmail(pending.email)))

  return [...dedupedPending, ...serverMembers]
}

export function upsertPendingProjectInvite(
  pendingInvites: WorkspaceMember[],
  serverMembers: WorkspaceMember[],
  email: string,
  role: WorkspaceMemberRole,
  projectId: string
): WorkspaceMember[] {
  const emailLower = normalizeInviteEmail(email)

  if (serverMembers.some((member) => normalizeInviteEmail(member.email) === emailLower)) {
    return pendingInvites
  }

  return [
    buildPendingMember(email, role, projectId, 'project-member'),
    ...pendingInvites.filter((member) => normalizeInviteEmail(member.email) !== emailLower),
  ]
}
